{
  "$schema": "https://cdn.us-east-1.prod.moon.dubai.aws.dev/wPjwkduJWkX3/PP8ofMnZY5LC/latest/schemas/settings-schema.json/index.json",
  "isPreview": {
    "type": "toggle",
    "label": "Preview mode",
    "config": {
      "default": false
    }
  },
  "cartEnabled": {
    "label": "Cart enabled",
    "type": "toggle",
    "config": {
      "default": true
    }
  },
  "buttonType": {
    "type": "radio",
    "label": "Button type",
    "config": {
      "default": "button_only",
      "options": [
        {
          "label": "Button only",
          "image": "/media/images/presets/Button-only.jpg",
          "value": "button_only"
        },
        {
          "label": "Widget",
          "image": "/media/images/presets/Widget.jpg",
          "value": "full_widget"
        }
      ]
    }
  },
  "colorMode": {
    "type": "radio",
    "label": "Color mode",
    "config": {
      "default": "light",
      "options": [
        {
          "label": "Light",
          "value": "light"
        },
        {
          "label": "Dark",
          "value": "dark"
        }
      ]
    }
  },
  "cornerStyle": {
    "type": "radio",
    "label": "Corner style",
    "config": {
      "default": "round",
      "options": [
        {
          "label": "Rounded",
          "value": "round"
        },
        {
          "label": "Square",
          "value": "square"
        },
        {
          "label": "Pill",
          "value": "pill"
        },
        {
          "label": "Custom",
          "value": "custom"
        }
      ]
    }
  },
  "borderRadius": {
    "type": "number",
    "label": "Border radius",
    "config": {
      "default": 4,
      "min": 0,
      "max": 30,
      "help": {
        "body": "The corner radius is the measurement of the curve of your button corners."
      },
      "description": "Define a pixel value for the corner radius to better match your design."
    }
  },
  "productSku": {
    "label": "Product SKU placeholder",
    "type": "text",
    "config": {
      "default": null,
      "labelStyle": "floating",
      "placeholder": "placeholder"
    }
  },
  "productId": {
    "label": "Product ID placeholder",
    "type": "text",
    "config": {
      "default": null,
      "labelStyle": "floating",
      "placeholder": "placeholder"
    }
  },
  "productExternalId": {
    "label": "Product external ID placeholder",
    "type": "text",
    "config": {
      "default": null,
      "labelStyle": "floating",
      "placeholder": "placeholder"
    }
  },
  "productAmazonSku": {
    "label": "Product Amazon SKU placeholder",
    "type": "text",
    "config": {
      "default": null,
      "labelStyle": "floating",
      "placeholder": "placeholder"
    }
  },
  "cartPosition": {
    "type": "radio",
    "label": "Placement",
    "config": {
      "default": "bottom_right",
      "options": [
        {
          "label": "Top left",
          "value": "top_left"
        },
        {
          "label": "Top right",
          "value": "top_right"
        },
        {
          "label": "Bottom left",
          "value": "bottom_left"
        },
        {
          "label": "Bottom right",
          "value": "bottom_right"
        }
      ]
    }
  },
  "recommendationOnCheckoutEnabled": {
    "type": "toggle",
    "label": "Recommendation on Checkout Page Enabled",
    "config": {
      "default": true
    }
  },
  "recommendationInCartEnabled": {
    "type": "toggle",
    "label": "Recommendation in Cart UI Enabled",
    "config": {
      "default": false
    }
  },
  "quantity": {
    "label": "Product quantity",
    "type": "text",
    "config": {
      "default": null
    }
  },
  "provider": {
    "label": "Provider used by merchant",
    "type": "text",
    "config": {
      "default": null
    }
  },
  "variantHelper": {
    "label": "That parameter enable additional functionality from EspAdapters",
    "type": "toggle",
    "config": {
      "default": true
    }
  }
}
